<template>
  <div class="popup">
    <span class="close-hldr" @click="close()">
      <i class="material-icons">
        close
      </i>
    </span>
    <div class="title">
      See how it works
    </div>
    <iframe
      src="https://www.youtube.com/embed/MCt1Ap_g71c"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'Demo-video-popup',
  methods: {
    close() {
      this.$emit('close', true)
    }
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 220px;
  border-radius: 5px;
}
.popup {
  position: fixed;
  top: 25%;
  width: 92%;
  margin: 4%;
  z-index: 2;
  background: #fff;
  padding: 10px 3% 25px;
  border-radius: 5px;
  .title {
    text-align: center;
    margin: 15px 0;
    text-decoration: none;
    color: $primary-color;
    font-size: 22px;
    color: $text-dark;
  }
  .close-hldr {
    position: absolute;
    right: 12px;
    top: 12px;
    display: flex;
    i {
      font-size: 15px;
      cursor: pointer;
      color: $grey-text;
    }
  }
}
</style>
